export const getTranscricaoErrorMessage = (error: unknown): string => {
  const responseData = (error as { response?: { data?: { message?: string; error?: string } } })
    ?.response?.data;

  return responseData?.message
    || responseData?.error
    || 'Ocorreu um erro inesperado. Tente novamente em instantes.';
};
